import React from 'react';
import PropTypes from 'prop-types';
import BackgroundColor from '../background-color/background-color';
import './border-banner.less';

const BorderBannerBackgroundWrapper = ({
  bgOptions,
  size,
  children,
  className,
}) => {
  const {
    backgroundImageSrcDesktop,
    backgroundImageSrcTablet,
    backgroundImageSrcMobile,
    backgroundImage,
    desktopAlignment,
    mobileAlignment,
    backgroundSize,
  } = bgOptions;

  const borderBannerImageSrcMap = {
    lg: backgroundImageSrcDesktop,
    md: backgroundImageSrcTablet,
    sm: backgroundImageSrcMobile,
  };

  return (
    <BackgroundColor bgOptions={bgOptions}>
      {(backgroundColor) => (
        <div
          className={className}
          style={{
            backgroundColor,
            backgroundImage:
              backgroundImage && `url(${borderBannerImageSrcMap[size]})`,
            backgroundSize: backgroundImage && backgroundSize,
            backgroundPosition:
              size && size !== 'sm'
                ? `${desktopAlignment}`
                : `${mobileAlignment}`,
          }}
        >
          {children}
        </div>
      )}
    </BackgroundColor>
  );
};

BorderBannerBackgroundWrapper.displayName = 'BorderBannerBackgroundWrapper';

BorderBannerBackgroundWrapper.propTypes = {
  size: PropTypes.string,
  className: PropTypes.string,
  bgOptions: PropTypes.shape({
    backgroundColor: PropTypes.string,
    hexColor: PropTypes.string,
    backgroundImage: PropTypes.bool,
    backgroundSize: PropTypes.oneOf(['contain', 'cover', 'auto']),
    desktopAlignment: PropTypes.oneOf(['left', 'center', 'right']),
    mobileAlignment: PropTypes.oneOf(['top', 'center', 'bottom']),
    backgroundImageSrcDesktop: PropTypes.string,
    backgroundImageSrcTablet: PropTypes.string,
    backgroundImageSrcMobile: PropTypes.string,
  }),
  children: PropTypes.func.isRequired,
};

BorderBannerBackgroundWrapper.defaultProps = {
  size: '',
  bgOptions: {
    hexColor: '',
    backgroundColor: 'green-dark',
    backgroundSize: 'cover',
    backgroundImageSrcDesktop: '',
    backgroundImageSrcTablet: '',
    backgroundImageSrcMobile: '',
    desktopAlignment: 'center',
    mobileAlignment: 'center',
    backgroundImage: false,
  },
};

export default BorderBannerBackgroundWrapper;
